import React, { memo } from "react";
import {
  ZoomableGroup,
  ComposableMap,
  Geographies,
  Geography
} from "react-simple-maps";

const geoUrl =
  "https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-110m.json";

const rounded = num => {
  if (num > 1000000000) {
    return Math.round(num / 100000000) / 10 + "Bn";
  } else if (num > 1000000) {
    return Math.round(num / 100000) / 10 + "M";
  } else {
    return Math.round(num / 100) / 10 + "K";
  }
};

const MapChart = ({ setTooltipContent }) => {
  return (
    <>
      <ComposableMap data-tip="" projectionConfig={{ scale: 170 }}>
        
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map(geo => (
                //console.log(geo);
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  onMouseEnter={() => {
                    const { NAME, POP_EST } = geo.properties;
                    if(NAME!='Antarctica'){
                    setTooltipContent(`${NAME} ${rounded(POP_EST)}`); }
                  }}
                  onMouseLeave={() => {
                    setTooltipContent("");
                  }}
                  style={{
                    default: {
                      fill: "#D6D6DA",
                      outline: "none"
                    },
                    hover: {
                      fill: "#3a8092",
                      outline: "none"
                    },
                    pressed: {
                      fill: "#3a8092",
                      outline: "none"
                    }
                  }}
                />
              ))
            }
          </Geographies>
        
      </ComposableMap>
    </>
  );
};

export default memo(MapChart);
